import React from "react";
import FeatureDetailLayout from "../components/FeatureDetailLayout";

export default function Coaching() {
  return (
    <FeatureDetailLayout
      seoTitle="Personalized Coaching"
      seoPath="/coaching"
      noindex
      eyebrow="Personalized Coaching"
      title="Your personal guidance for"
      highlight="peak performance"
      description="Jollof Fit Kingdom's personalized coaching learns from your training, nutrition, recovery and body composition to deliver guidance that adapts to you — the way an elite coach would, built around your goals."
      eagle
      benefits={[
        { icon: "Brain", title: "Adaptive guidance", desc: "Plans evolve automatically based on your performance, fatigue and goals — never static, always personal." },
        { icon: "Target", title: "Goal-aware coaching", desc: "Whether it's strength, fat loss or endurance, your coaching optimizes every decision toward your objective." },
        { icon: "Activity", title: "Real-time adjustments", desc: "Recovery low today? Your session intensity is recalibrated before you even open the app." },
        { icon: "Mic", title: "Voice coaching", desc: "Talk to your Coach using voice and get clear, spoken guidance and answers when you enable microphone access." },
        { icon: "TrendingUp", title: "Progressive overload", desc: "Automatic progression logic ensures you keep improving without plateaus or overtraining." },
        { icon: "ShieldCheck", title: "Safety first", desc: "Health-aware recommendations respect your limits, history and personal context." },
      ]}
      howItWorks={[
        { title: "Connect your data", desc: "Sync wearables, smart scales and nutrition logs so your coaching understands your full picture." },
        { title: "Get your plan", desc: "A personalized program is built across training, nutrition and recovery." },
        { title: "Improve daily", desc: "Every session refines your guidance, making tomorrow sharper than today." },
      ]}
    />
  );
}
